// config.js
// Insert your YouTube Data API v3 key below
const config = {
  YOUTUBE_API_KEY: "AIzaSyAUlkBfSEOAvzlDQN7pwjH2pzVtSL6bDIE",
};

export default config;
